import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { parseMedia } from "../lib/media";
import MediaItem from "../components/MediaItem";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "image", label: "Photos" },
  { id: "youtube", label: "YouTube" },
  { id: "facebook", label: "Facebook" },
];

const GalleryPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "all" ? items : items.filter((g) => parseMedia(g.image_url).type === filter);

  return (
    <main className="pt-32 pb-24 min-h-screen" data-testid="gallery-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Gallery</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2">Moments at Innovative Preschool</h1>
          <p className="mt-3 text-[color:var(--text-secondary)]">
            Photos, Facebook reels and YouTube videos — all in one place.
          </p>
        </div>

        <div className="flex justify-center gap-2 mb-10 flex-wrap" role="tablist" aria-label="Filter media type">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              role="tab"
              aria-selected={filter === f.id}
              data-testid={`gallery-filter-${f.id}`}
              className={`px-5 py-2 rounded-full text-sm font-bold transition ${
                filter === f.id ? "bg-brand-blue text-white" : "bg-white hover:bg-light-blue text-[color:var(--text-primary)]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center text-[color:var(--text-secondary)]">Loading photos...</div>
        ) : filtered.length === 0 ? (
          <div className="text-center text-[color:var(--text-secondary)]">No items in this category yet.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((g, i) => {
              const m = parseMedia(g.image_url);
              const aspect = m.type === "facebook" && m.aspect === "9/16" ? "aspect-[9/16]" : m.type === "youtube" ? "aspect-video" : m.type === "facebook" ? "aspect-video" : "aspect-[4/3]";
              return (
                <div key={g.id} className="card-soft overflow-hidden bg-white rounded-[1.75rem]" data-testid={`gallery-item-${i}`}>
                  <MediaItem url={g.image_url} caption={g.caption} aspectClassName={aspect} testId={`gallery-media-${i}`} cacheBust={g.created_at} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
};

export default GalleryPage;
